/**
 * Feature flags for finendra.com experiments and rollouts.
 */

export interface PricingConfig {
  starterPrice: number;
  starterDisplay: string;
  isDiscounted: boolean;
}

/**
 * Gets the current pricing configuration.
 * Can be controlled via:
 * 1. URL search parameter: ?ab_starter=399
 * 2. Environment variable: VITE_STARTER_PRICE=399
 * 3. Default: $499/mo
 */
export function getStarterPricing(searchParam?: string | null): PricingConfig {
  let price = 199;

  if (searchParam === "199" || searchParam === "essential199") {
    price = 199;
  } else if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    const ab = urlParams.get("ab_starter");
    if (ab === "199") {
      price = 199;
    }
  }

  return {
    starterPrice: price,
    starterDisplay: `$${price}`,
    isDiscounted: price < 199,
  };
}
